import * as client from '../../services/client';
import { TYPES } from '../../common/constants';
import { startLoading,stopLoading, startFormLoading, stopFormLoading } from './loader'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { setPropertyWalkThroughFormData,getAreaAndSubAreaStatus } from '../actions/propertyWalkThroughForm'
import { fetchServiceRequestByAssetId } from './serviceRequest';

import { fetchSuiteCounts } from './suites';

const fetchAreasAndSubAreasDone = payload => ({
    type: TYPES.FETCH_AREAS_AND_SUB_AREAS,
    payload,
  });
  
  // export const fetchAreasAndSubAreas = (suiteId) => dispatch => {
  //   return client.getAreasAndSubAreasBySuiteId(suiteId)
  export const fetchWalkthroughServiceRequestsListByAsset = (assetId,walkthroughId) => dispatch =>{
    dispatch(startFormLoading())
    let response = [];
     client.getWalkthroughServiceRequestListByAsset(assetId,walkthroughId)
    .then(
      response => {
        if(response.ok || response.status === 200){
          dispatch(stopFormLoading())
          response.json().then(responsejson =>
            { 
               response = responsejson      
            }
            )
        }
      }
    );
    return response
  }
  export const fetchAreasAndSubAreas = (walkthroughId) => dispatch => {
    return client.getAreasAndSubAreasBySuiteId(walkthroughId)
      .then(
        response => {
          if(response.ok || response.status === 200){
            response.json().then(responsejson => {               
                dispatch(fetchAreasAndSubAreasDone(responsejson.data))
              })
          }
        }
      );
  };

  export const instantfetchAreasAndSubAreas = (suiteId,dispatch)=> {
    return client.getAreasAndSubAreasBySuiteId(suiteId)
      .then(
        response => {
          if(response.ok || response.status === 200){
            response.json().then(responsejson =>
              dispatch(fetchAreasAndSubAreasDone(responsejson.data))
              )
          }
        }
      );
  };

  const addAssetDone = payload => ({
    type:TYPES.ADD_ASSET_DONE,
    payload
  })

  const setValidation = (payload) => ({
    type:TYPES.SET_VALIDATION,
    payload
  })
  
  export const saveAssetConfig = (params,walkthroughId) => dispatch => {
    dispatch(startFormLoading())
    return client.addAsset(params).then(
      response =>{
        dispatch(stopFormLoading())
        if(response.ok || response.status === 200){
          response.json().then(
            responsejson => {
              if(responsejson.statusCode === 402){
                dispatch(setValidation('Serial Number already exists please try with other'))
                toast.error('🚫 Serial Number already exists please try with other',{autoClose:12000,position:'top-center'})
              }else{
                toast.success('Asset has been added.',{autoClose: 10000,position:'top-center'});
                dispatch(fetchSuiteCounts(params.UnitId))
                dispatch(setValidation('Success'))

                if(walkthroughId){
                  dispatch(fetchAreasAndSubAreas(walkthroughId))
                }
                
                
                dispatch(addAssetDone(responsejson.data))

              }
              
          }
          )
  
        }
      }
    )
  }

  // const deleteSubAreaDone = payload => ({
  //   type: TYPES.DELETED_SUB_,
  //   payload,
  // });
  export const deleteSubArea = (subAreaId,walkthroughId) =>dispatch =>{
    return client.deleteSubArea(subAreaId).then( response => {
      if( response.status === 200 || response.ok){
          response.json().then(
            responsejson => {
              toast.success("ⓘ Asset has been removed from this suite's walkthrough.",{autoClose: 10000,position:'top-center'});
              dispatch(fetchAreasAndSubAreas(walkthroughId))
            }
          )
          
      }
    })
  }

  export const saveSubAreaDescription = ( data,walkthroughId ) => dispatch =>{     
    dispatch(startFormLoading())
    return client.saveSubAreaDescription(data).then(
      response => {
        dispatch(stopFormLoading())
        if( response.status === 200 || response.ok){
          response.json().then( responsejson =>{
            if(responsejson && responsejson.statusCode === 500) {
              dispatch(fetchAreasAndSubAreas(walkthroughId))
            } else {
              toast.success('ⓘ Sub-area has been saved.',{autoClose: 10000,position:'top-center'})
            let data = responsejson.data.length > 0 ? responsejson.data[0] : null ;
            if(data !== null){
              dispatch(setPropertyWalkThroughFormData({
                // type: 'Area',
                subAreaDescription:data.description ? data.description : '',
                checkList:data.walkthroughChecklistItems,
                walkthroughFAQDetails:data.walkthroughFAQDetails,
                walkThroughMedia:data.walkThroughMedia,
                walkthroughStatus:data.walkthroughStatus,
                questions:data.questions.length > 0 ? data.questions : []
              }))
            }
            dispatch( getAreaAndSubAreaStatus(data.unitId))
            dispatch(fetchAreasAndSubAreas(walkthroughId))
          }
          })
        }
      }
    )
  }
  

  export const fetchSubAreaData = (subAreaId, areaId,tmp, walkthroughId) => dispatch =>{
    dispatch(startLoading())
    let tmps = tmp === 'easy' ? '1' : '0'
    return client.fetchSubAreaData(subAreaId, walkthroughId, '0').then( response => {
       if( response.status === 200 || response.ok){
         response.json().then( responsejson =>{
          let data = responsejson.data.length > 0 ? responsejson.data[0] : null ;
          if(data !== null){
            dispatch( setPropertyWalkThroughFormData({
              itemId:data.itemId,
              subAreaDescription:data.description,
              checkList:data.walkthroughChecklistItems,
              walkthroughFAQDetails:data.walkthroughFAQDetails,
              walkThroughMedia:data.walkThroughMedia,
              // serviceRequest:data.serviceRequest.length > 0 ? data.serviceRequest[0]:[],
              questions:data.questions.length > 0 ? data.questions : []
            }))
          }
          dispatch(stopLoading())
           
         })
       }
    })
  }

  export const fetchAreaData = (suiteId, areaId) => dispatch => {
    dispatch(startLoading())
    return client.fetchAreaData(suiteId, areaId).then(response => {
      if(response.ok || response.status === 200) {
        response.json().then(responsejson => {
         let data = responsejson.data.length > 0 ? responsejson.data[0] : null;
          if(data !== null){
            dispatch(setPropertyWalkThroughFormData({
              type: 'Area',
              subAreaId:data.id,
              subAreaDescription:data.description ? data.description : '',
              checkList:data.walkthroughChecklistItems,
              walkthroughFAQDetails:data.walkthroughFAQDetails,
              walkThroughMedia:data.walkThroughMedia,
              walkthroughStatus:data.walkthroughStatus
            }))
            dispatch(stopLoading())
          }
         })
      }
    })
  }
  
  export const saveAreaDescription = ( data,walkthroughId ) => dispatch =>{  
    dispatch(startFormLoading())   
    return client.saveAreaDescription(data).then(
      response => {
        dispatch(stopFormLoading())
        if( response.status === 200 || response.ok){
          response.json().then( responsejson =>{
          toast.success('ⓘ Area has been saved.',{autoClose:10000,position:'top-center'})
         
            let data = responsejson.data.length > 0 ? responsejson.data[0] : null;
            if(data !== null){
              dispatch(setPropertyWalkThroughFormData({
                type: 'Area',
                subAreaDescription:data.description ? data.description : '',
                checkList:data.walkthroughChecklistItems,
                walkthroughFAQDetails:data.walkthroughFAQDetails,
                walkThroughMedia:data.walkThroughMedia,
                walkthroughStatus:data.walkthroughStatus
              }))
            }
            dispatch(getAreaAndSubAreaStatus(data.unitId))
            dispatch(fetchAreasAndSubAreas(walkthroughId))
            // instantfetchAreasAndSubAreas(suiteId,dispatch)
          })
        }
      }
    )
  }

    export const fetchSuiteCheckList = (walkthroughId) => dispatch => {
      return client.fetchSuiteCheckList(walkthroughId).then(
      response => {
        if(response.status === 200 && response.ok){
            response.json().then( responsejson => {
              if(responsejson.data){
                dispatch(
                  setPropertyWalkThroughFormData({
                    sideBarCheckList: responsejson.data
                  })
                )
              }
            })
        }
      }
    )
  }

  export const changeSequenceAreasAndSubAreasDone = (payload1, payload2) => ({
    type: TYPES.CHANGE_SEQUENCE_AREAS_AND_SUBAREAS,
    payload1,
    payload2
  });

  export const changeSequenceAreaOrder = (params, walkthroughId) => dispatch => {
    return client.updateWalkThroughRoomSequence(params).then(
      response => {
        if(response.status === 200 && response.ok){
            response.json().then( responsejson => {
              dispatch(fetchAreasAndSubAreas(walkthroughId))
            })
          }
        })
  }